import React from 'react';
import PropTypes from 'prop-types';
import { Rnd } from 'react-rnd';
import { useField } from 'formik';

function Draggable({ fieldName, children }) {
    const [, meta, helpers] = useField(fieldName);
    const { value } = meta;
    const { setValue } = helpers;
    const [isHovered, setIsHovered] = React.useState(false);

    return (
        <div className="position-relative">
            <Rnd
                default={value}
                onDragStop={(e, d) => {
                    setValue({ ...value, x: d.x, y: d.y });
                }}
                // eslint-disable-next-line no-unused-vars
                onResizeStop={(e, direction, ref, delta, position) => {
                    setValue({ ...value, width: ref.style.width, height: ref.style.height });
                }}
                className={isHovered ? 'border-dashed' : ''}
                onMouseOver={() => setIsHovered(true)}
                onMouseOut={() => setIsHovered(false)}
                // bounds=".font-face-aAtmospheric"
            >
                {children}
            </Rnd>
        </div>
    );
}

Draggable.propTypes = {
    fieldName: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};
export default Draggable;
